import { IFeaturedPlaylistsResponse } from '#/types/API/featuredPlaylists';
import { IAlbumDetails } from '#/types/API/newReleasedAlbums';
import { ITopArtist } from '#/types/API/topArtists';
import { ITopTrack } from '#/types/API/topTracks';

import withMatcher from '#/utils/withMatcher';

export const createActionHomeAddNewReleasedAlbums = withMatcher(
  (payload: IAlbumDetails[]) => {
    return {
      type: 'home/add_new_released_albums',
      payload,
    };
  }
);

export const createActionHomeLoadingNewReleasedAlbums = withMatcher(() => {
  return {
    type: 'home/loading_new_released_albums',
  };
});

export const createActionHomeErrorNewReleasedAlbums = withMatcher(() => {
  return {
    type: 'home/error_new_released_albums',
  };
});

export const createActionHomeAddTopArtists = withMatcher(
  (payload: ITopArtist[]) => {
    return {
      type: 'home/add_top_artists',
      payload,
    };
  }
);

export const createActionHomeLoadingTopArtists = withMatcher(() => {
  return {
    type: 'home/loading_top_artists',
  };
});

export const createActionHomeErrorTopArtists = withMatcher(() => {
  return {
    type: 'home/error_top_artists',
  };
});

export const createActionHomeAddTopTracks = withMatcher(
  (payload: ITopTrack[]) => {
    return {
      type: 'home/add_top_tracks',
      payload,
    };
  }
);

export const createActionHomeLoadingTopTracks = withMatcher(() => {
  return {
    type: 'home/loading_top_tracks',
  };
});

export const createActionHomeErrorTopTracks = withMatcher(() => {
  return {
    type: 'home/error_top_tracks',
  };
});

export const createActionHomeAddFeaturedPlaylists = withMatcher(
  (payload: IFeaturedPlaylistsResponse) => {
    return {
      type: 'home/add_featured_playlists',
      payload,
    };
  }
);

export const createActionHomeLoadingFeaturedPlaylists = withMatcher(() => {
  return {
    type: 'home/loading_featured_playlists',
  };
});

export const createActionHomeErrorFeaturedPlaylists = withMatcher(() => {
  return {
    type: 'home/error_featured_playlists',
  };
});